import {
  Children,
  cloneElement,
  ComponentPropsWithRef,
  FC,
  PropsWithChildren,
  ReactElement,
} from 'react';

import FrequentlyAskedQuestion from './FrequentlyAskedQuestion';

type FAQElement = ReactElement<ComponentPropsWithRef<typeof FrequentlyAskedQuestion>>;

const { map, toArray } = Children;

const FirstFAQIsOpen: FC<PropsWithChildren> = ({ children }) =>
  // `Children.map` maps over all children, *including* `null` and friends,
  // so we first pass `children` through `Children.toArray`, which also
  // removes null-ish values.
  map(toArray(children), (child, index) =>
    cloneElement(child as FAQElement, index === 0 ? { isOpen: true } : undefined)
  );

export default FirstFAQIsOpen;
